<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display:flex;justify-content:flex-start;align-items:center;">
        <el-radio-group v-model="requestData.timeType" style="margin-right:5px">
          <el-radio-button label="MONTH">按月</el-radio-button>
          <el-radio-button label="YEAR">按年</el-radio-button>
        </el-radio-group>
        <div style="margin-right: 10px;">物业代收月份</div>
        <el-date-picker v-if="requestData.timeType==='MONTH'" v-model="requestData.month" type="month" format='yyyy-MM' value-format="yyyy-MM" size="small" style="width: 180px;margin-right:10px" placeholder="选择月份"></el-date-picker>
        <el-date-picker v-if="requestData.timeType==='YEAR'" v-model="requestData.month" value-format="yyyy" type="year" placeholder="选择年" style="width: 180px;margin-right:10px"/>
        <button-add @click="toAddPage" value="手动生成报表" v-if="permissionCodes.indexOf('040002001') !== -1"></button-add>
      </div>
    <div style="display: flex;justify-content: space-between">
        <button-export
        :href="exportUrl"
        :beforeDownload="beforeDownload"
        style="margin: 0 0 0 8px"
        download="download.xls"
        v-if="permissionCodes.indexOf('040002002') !== -1"
        value="导出"/>
    </div>
    </div>
    <el-table
    :data="tableData"
    :header-cell-style="{'text-align':'center'}"
    :cell-style="{'text-align':'center'}"
    style="width: 100%;">
    <el-table-column label="抵扣项">
      <el-table-column
        prop="propertySalary"
        label="物业工资">
      </el-table-column>
        <el-table-column
          prop="deductionCount"
          label="小计">
        </el-table-column>
    </el-table-column>
    <el-table-column label="物业代收费用">
        <el-table-column
          prop="propertyFee"
          label="物业管理费">
        </el-table-column>
        <el-table-column
          prop="parkingSpaceFee"
          label="车位管理费">
        </el-table-column>
        <el-table-column
          prop="stopFee"
          label="临时停车费用">
        </el-table-column>
        <el-table-column
          prop="venueFee"
          label="会议室、场地租用">
        </el-table-column>
        <el-table-column
          prop="otherFee"
          label="其他管理费">
        </el-table-column>
        <el-table-column
          prop="receiveCount"
          label="小计">
        </el-table-column>
    </el-table-column>
        <el-table-column
          prop="resultAmount"
          label="抵扣结果(付款情况)">
        </el-table-column>
        <el-table-column
          prop="memo"
          label="备注">
        </el-table-column>
    </el-table-column>
  </el-table>

  <el-pagination
    background
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    style="margin-top:15px"
    :page-sizes="[10, 20, 50, 100]"
    :current-page="requestData.pageNum"
    :page-size="requestData.pageSize"
    layout="total, sizes, prev, pager, next, jumper"
    :total="total">
  </el-pagination>

  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/PropertyFee";
import { bus } from "../../../utils/bus";
import { errorHandler } from "../../../utils/errorHandler";
import ButtonAdd from "../../../components/common/buttons/button-add";
import { nError, nSuccess, nAlert } from "../../../utils/notice";

export default {
  components: {
    ButtonAdd,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    Breadcrumb
  },
  name: "property-collection-fee",
  data() {
    return {
      breadcrumb: [
        {
          value: "纳爱斯专属",
          name: "property-fee-management"
        },
        {
          value: "物业代收费用"
        }
      ],
      tableData: [],
      requestData: {
        pageSize: 10,
        pageNum: 1,
        month: `${new Date().getFullYear()}-${
          new Date().getMonth() + 1 < 10 ? 0 : ""
        }${new Date().getMonth() + 1}`,
        timeType: "MONTH"
      },
      exportUrl: "",
      total: 0,
      permissionCodes: ""
    };
  },
  created() {
    this.getPage();
    this.permissionCodes = bus.global.permissionCodes;
  },
  activated() {
    this.getPage();
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportPropertyCost}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&month=${
        this.requestData.month ? this.requestData.month : ""
      }`;
    },
    getPage() {
      this.$axios
        .post(api.getPropertyFeePage, this.requestData)
        .then(res => {
          this.tableData = res.data.data.list;
          this.total = res.data.data.total;
        })
        .catch(errorHandler("获取物业代收费用分页失败"));
    },
    toAddPage() {
      if (!this.requestData.month) {
        nError("请先选择物业代收月份");
        return false;
      }
      this.$confirm("报表生成后不可更改，是否继续？", "温馨提示", {
        type: "warning"
      }).then(() => {
        this.$axios
          .post(api.generateReport, { month: this.requestData.month })
          .then(res => {
            nSuccess("生成报表成功");
            this.getPage();
          })
          .catch(errorHandler("手动生成报表失败"));
      });
    },
    handleSizeChange(val) {
      this.requestData.pageSize = val;
      this.getPage();
    },
    handleCurrentChange(val) {
      this.requestData.pageNum = val;
      this.getPage();
    }
  },
  watch: {
    "requestData.month": {
      handler(newName, oldName) {
        this.getPage();
      },
      deep: true
    },
    "requestData.timeType": {
      handler() {
        this.requestData.month = "";
        this.getPage();
      },
      deep: true
    }
  }
};
</script>


<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
.btn-box {
  .el-date-editor .el-range-separator {
    padding: 0;
  }
}
</style>

<style scoped lang="less">
/deep/.el-radio-button__inner {
  line-height: 32px;
  height: 32px;
  padding: 0 20px;
}
/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #3276ff;
  border-color: #3276ff;
}
</style>



// WEBPACK FOOTER //
// src/view/PropertyFee/PropertyCollectionFee/PropertyCollectionFee.vue